import dayjs from 'dayjs'
import { Moment, isMoment } from 'moment';

export const Formats = {
  date: 'MM/DD/YYYY',
  time: 'h:mm a',
  datetime: 'MM/DD/YYYY h:mm a'
}

export const getFormat = (mode: 'date' | 'time' | 'datetime', format?: string) => {
  return format || Formats[mode]
}

export const prepareDateString = (date: string | null | Moment, format: string): string | null => {
    const dateString = isMoment(date) ? date.format(format) : date
    return dateString ? dateString.replace(/AM$/, "am").replace(/PM$/, "pm") : null
}

export const calculateDayjsValue = (date: string | null | Moment, format: string): dayjs.Dayjs | null => {
  const dateString = prepareDateString(date, format)
  if (dateString) {
    const value = dayjs(dateString, format)
    if (value.isValid()) {
      return value;
    }
  }
  return null
}
